import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-left" maskId="round-filled-radius-1-stroke-1.5-IconArrowPathLeft"><path d="M8.90212 4.3931C9.71239 3.69536 10.9678 4.27103 10.9678 5.34031V7.99992H20.2178C21.1843 7.99992 21.9678 8.78342 21.9678 9.74992V14.2499C21.9678 15.2164 21.1843 15.9999 20.2178 15.9999H10.9678V18.6595C10.9678 19.7288 9.71239 20.3045 8.90212 19.6067L1.60837 13.326C0.79759 12.6278 0.797592 11.372 1.60837 10.6738L8.90212 4.3931Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathLeft;
